import { StandardEvents } from '@shopify/events';

const VISIBLE_DURATION = 4500;

/** @type {number | undefined} */
let hideTimer;

/** @returns {HTMLElement | null} */
function getToast() {
  return document.querySelector('[data-cart-toast]');
}

function hideToast() {
  const toast = getToast();
  if (!toast) return;
  clearTimeout(hideTimer);
  toast.classList.remove('cart-toast--visible');
}

/**
 * Looks up the titles of the added variants in the cart.
 * @param {{ merchandiseId: string | number }[]} lines
 * @returns {Promise<string[]>}
 */
async function getAddedTitles(lines) {
  try {
    const response = await fetch(`${window.Theme?.routes?.cart_url ?? '/cart'}.js`, {
      headers: { Accept: 'application/json' },
    });
    const cart = await response.json();
    const ids = lines.map((line) => String(line.merchandiseId).split('/').pop());
    return ids
      .map((id) => cart.items.find((item) => String(item.variant_id) === id)?.product_title)
      .filter(Boolean);
  } catch {
    return [];
  }
}

/**
 * @param {number} quantity
 * @param {string[]} titles
 */
function showToast(quantity, titles) {
  const toast = getToast();
  if (!toast) return;

  const message = toast.querySelector('[data-cart-toast-message]');
  if (message) {
    const template = quantity > 1 ? toast.dataset.messageMany : toast.dataset.messageOne;
    message.textContent = (template ?? '').replace('{{ count }}', String(quantity));
  }

  const title = toast.querySelector('[data-cart-toast-title]');
  if (title) {
    title.textContent = titles.length > 1 ? `${titles[0]} + ${titles.length - 1}` : (titles[0] ?? '');
    /** @type {HTMLElement} */ (title).hidden = titles.length === 0;
  }

  // Restart the transition when a second add happens while the toast is still visible.
  toast.classList.remove('cart-toast--visible');
  void toast.offsetWidth;
  toast.classList.add('cart-toast--visible');

  clearTimeout(hideTimer);
  hideTimer = window.setTimeout(hideToast, VISIBLE_DURATION);
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;

  const quantity = event.lines.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);

  event.promise
    ?.then(({ userErrors }) => {
      if (userErrors?.length) return;
      return getAddedTitles(event.lines).then((titles) => showToast(quantity || 1, titles));
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[cart-toast] Event promise rejected:', error);
    });
});

document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('[data-cart-toast-close]')) hideToast();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') hideToast();
});
